import React, { useEffect, useRef } from 'react';
import { Password } from 'primereact/password';
import { useField } from 'formik';

const PasswordField = ({
  placeholder = '',
  label = '',
  name = '',
  className = '',
  isIcon = false,
  icon,
  iconPos = 'left',
  iconClassName = '',
  defaultValue = '',
  type = 'password',
  parentClass = '',
  ...props
}) => {
  const [field, meta] = useField(name);
  const passwordRef = useRef(null);

  useEffect(() => {
    // Fix RTL and vertical alignment for password icon
    const fixRTLIcon = () => {
      const dir = document.documentElement.getAttribute('dir');
      setTimeout(() => {
        const icons = document.querySelectorAll('.p-password-show-icon, .p-password-hide-icon');
        icons.forEach(icon => {
          icon.style.top = '50%';
          icon.style.transform = 'translateY(-50%)';
          icon.style.marginTop = '0px';
          if (dir === 'rtl') {
            icon.style.left = '0.75rem';
            icon.style.right = 'auto';
            if (icon.parentElement) {
              icon.parentElement.style.left = '0.75rem';
              icon.parentElement.style.right = 'auto';
            }
          } else {
            icon.style.right = '0.75rem';
            icon.style.left = 'auto';
            if (icon.parentElement) {
              icon.parentElement.style.right = '0.75rem';
              icon.parentElement.style.left = 'auto';
            }
          }
        });
      }, 50);
    };

    fixRTLIcon();
    const observer = new MutationObserver(fixRTLIcon);
    if (passwordRef.current) {
      observer.observe(passwordRef.current, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className={`flex flex-col gap-1 w-full mb-1 ${parentClass}`} ref={passwordRef}>
      <label htmlFor={name} className='input-label'>
        {label}
      </label>
      <div className='relative'>
        <Password
          id={name}
          placeholder={placeholder}
          type={type}
          {...field}
          {...props}
          className={`relative input-field ${className} ${isIcon && iconPos === 'left' ? '!pl-10' : iconPos === 'right' ? '!pr-10' : ''
            } `}
          pt={{
            root: { className: `border border-gray-300 !w-full !h-full !p-0 !py-0 !pe-0 ${icon ? '' : '!ps-2 !pl-0'}` },
            iconField: { root: { className: 'w-full' } },
            input: {
              className:
                '!p-[0.6rem] !w-full !h-full !border-0 focus:outline-none !bg-gray-100 focus:shadow-none focus:bg-gray-100 !pl-[0] !pr-10'
            },
            panel: { className: 'hidden' },
            showIcon: {
              className: '!top-1/2 !-translate-y-1/2 !mt-0 !right-3 [dir="rtl"]_&:!right-auto [dir="rtl"]_&:!left-3',
              style: document.documentElement.getAttribute('dir') === 'rtl' ? { right: 'auto', left: '0.75rem' } : { right: '0.75rem', left: 'auto' }
            },
            hideIcon: {
              className: '!top-1/2 !-translate-y-1/2 !mt-0 !right-3 [dir="rtl"]_&:!right-auto [dir="rtl"]_&:!left-3',
              style: document.documentElement.getAttribute('dir') === 'rtl' ? { right: 'auto', left: '0.75rem' } : { right: '0.75rem', left: 'auto' }
            }
          }}
        />
        {isIcon && (
          <div
            className={`absolute top-1/2 transform -translate-y-1/2 ${iconPos === 'left' ? 'left-3' : 'left-auto right-3'
              } text-iconC ${iconClassName}`}
          >
            {icon}
          </div>
        )}
      </div>
      {meta.error && meta.touched && <p className='text-sm text-red-500'>{meta.error}</p>}
    </div>
  );
};

export default PasswordField;
